import TranslationText from '@Components/Utilities/TranslationText';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';


const BlogArticleCategories = (props) => {
    return (
        <div className='blog-list-right-menu'>
            <div className='blog-list-right-menu-header'>
                <i className='fas fa-th-large' aria-hidden='true' /> &nbsp; <TranslationText tKey='sandhills.tradepubwebsite.mvc.categories' />
            </div>
            <div className='blog-list-right-menu-cats'>
                {props.Categories && props.Categories.length > 0 && props.Categories.map((category, index) =>
                    <div key={index}>
                        <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h2 className="header-reset">{children}</h2>}>
                            <a href={category.LinkUrl} dangerouslySetInnerHTML={{ __html: category.LinkText }} />
                        </ConditionalWrapper>
                    </div>)}
            </div>
        </div>
    );
};

export default BlogArticleCategories;